
import React from 'react';
import PropTypes from 'prop-types';

const PrepTimeIcon = ({ className }) => {
  return (
    <svg
      width="19"
      height="22"
      viewBox="0 0 19 22"
      fill="none"
      className={`fill-current ${className}`}
      xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M9.5 6.25C9.91421 6.25 10.25 6.58579 10.25 7V12C10.25 12.4142 9.91421 12.75 9.5 12.75C9.08579 12.75 8.75 12.4142 8.75 12V7C8.75 6.58579 9.08579 6.25 9.5 6.25Z" fill="currentColor"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M9.5 4.25C5.08421 4.25 1.5 7.83421 1.5 12.25C1.5 16.6658 5.08421 20.25 9.5 20.25C9.91421 20.25 10.25 20.5858 10.25 21C10.25 21.4142 9.91421 21.75 9.5 21.75C4.25579 21.75 0 17.4942 0 12.25C0 7.00579 4.25579 2.75 9.5 2.75C14.7442 2.75 19 7.00579 19 12.25C19 12.6642 18.6642 13 18.25 13C17.8358 13 17.5 12.6642 17.5 12.25C17.5 7.83421 13.9158 4.25 9.5 4.25Z" fill="currentColor"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M5.75 1C5.75 0.585786 6.08579 0.25 6.5 0.25H12.5C12.9142 0.25 13.25 0.585786 13.25 1C13.25 1.41421 12.9142 1.75 12.5 1.75H6.5C6.08579 1.75 5.75 1.41421 5.75 1Z" fill="currentColor"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M13.4398 15.5339C13.3413 15.5907 13.1504 15.7877 13.1504 16.3403V18.6703C13.1504 19.2229 13.3413 19.4199 13.4398 19.4767C13.5381 19.5334 13.8043 19.6002 14.2838 19.3217L16.2838 18.1617C16.7656 17.8819 16.8404 17.6181 16.8404 17.5053C16.8404 17.3925 16.7656 17.1287 16.2838 16.8489L14.2841 15.6891C13.8046 15.4106 13.5381 15.4773 13.4398 15.5339ZM15.0367 14.3915C14.2763 13.9501 13.4125 13.8184 12.6909 14.2342C11.9695 14.6499 11.6504 15.4629 11.6504 16.3403V18.6703C11.6504 19.5477 11.9695 20.3607 12.6909 20.7764C13.4126 21.1922 14.2765 21.0605 15.037 20.6189L17.0367 19.4591C17.7948 19.0189 18.3404 18.3375 18.3404 17.5053C18.3404 16.6731 17.7952 15.9919 17.037 15.5517L15.0367 14.3915C15.0368 14.3916 15.0366 14.3915 15.0367 14.3915Z" fill="currentColor"/>
    </svg>
  );
};

PrepTimeIcon.propTypes = {
  className: PropTypes.string, // Optional: allows passing Tailwind or custom classes
};

PrepTimeIcon.defaultProps = {
  className: '', // Default to an empty string
};

export default PrepTimeIcon;